import {Box, Stack} from "@chakra-ui/react";
import React from "react";

import RadioOrCheckbox from "../../shared/components/RadioOrCheckbox";
import RadioOrCheckboxGroup from "../../shared/components/RadioOrCheckboxGroup";
import RenderResource from "../../shared/components/RenderResource";
import RenderText from "../../shared/components/RenderText";
import { OptionDto } from "../../shared/model/Dto";
import {validResourceExtension} from "../../shared/Utils";

type OptionGroupProps = {
  options: OptionDto[];
  isLoading: boolean;
  optionIds: string[];
  multipleChoice: boolean;
  onChange: (optionIds: string[]) => void;
};

const Options = (props: OptionGroupProps) => {

  return (
    <Box paddingBottom="10" translate="no">
      <RadioOrCheckboxGroup
        multipleChoice={props.multipleChoice}
        values={props.optionIds}
        onChange={props.onChange}
      >
        <Stack>
          {props.options.map((option: OptionDto) => (
            <RadioOrCheckbox
              multipleChoice={props.multipleChoice}
              key={option.id}
              value={option.id}
              isDisabled={props.isLoading}
            >
              { validResourceExtension(option.text)
                ? <RenderResource resource={option.text} compact={true} text={option.option} />
                : <RenderText id={option.text.substring(0, 50)}
                            content={option.text} compact={true} />
                //<Markdown content={option.text} compact={true} bigFont={props.bigFont}/>
              }
            </RadioOrCheckbox>
          ))}
        </Stack>
      </RadioOrCheckboxGroup>

    </Box>
  );
};

export default Options;
